import Button from 'src/components/atoms/Button';
import { Row } from 'src/components/atoms/Row';
import Text from 'src/components/atoms/Text';

import styled, { css } from 'styled-components/macro';

export const BorderBox = css`
  padding: 24px 24px;
  border: 2px solid ${({ theme }) => theme.color.gray[200]};
  border-radius: 4px;
  align-self: stretch;
  > div {
    height: 100%;
  }
`;

export const BorderContainer = styled.div`
  ${BorderBox};
`;

export const CallBox = styled(Row.Col).attrs(() => ({
  size: '70%'
}))`
  ${BorderBox};
`;

export const TeamBox = styled(Row.Col).attrs(() => ({
  size: '30%'
}))``;

export const CancelButton = styled(Button)`
  color: ${({ theme }) => theme.color.blue[700]};
  border: unset;
  display: block;
  text-decoration: underline;
  padding: 2px;
  height: unset;
  margin: 20px 0 5px 0;
`;

export const StyledText = styled(Text)`
  max-width: 80%;
`;

export const SubmissionRequestedText = styled(Text)`
  display: block;
  margin: 15px 0 10px 2px;
`;

export const StyledRow = styled(Row)`
  display: block;
`;

export const SpecialtyQueueRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
`;

export const SpecialtyQueueValue = styled(Text)`
  font-weight: 600;
  color: ${({ theme }) => theme.color.blue[700]};
`;
